"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalloutRoundTiny = exports.CalloutRoundSm = exports.CalloutHeader = exports.Callout = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.callout.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========== CALLOUT ========== */

class Callout extends _react.Component {
  render() {
    const columnGridStyle = this.props.columnCount ? 'grid' + 12 / this.props.columnCount : 'grid4';
    const calloutGridStyle = this.props.direction && this.props.direction === 'horizontal' ? 'grid6' : 'grid12';
    const calloutImageStyle = this.props.direction && this.props.direction === 'horizontal' ? 'round-img-container callout-image callout-image-horiz' : 'round-img-container callout-image';
    const calloutTarget = this.props.url && this.props.url.substring(0, 4).toLowerCase() === 'http' ? '_blank' : '_self';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'column callout ' + columnGridStyle
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: calloutGridStyle
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: calloutImageStyle
    }, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: calloutTarget,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.img,
      alt: this.props.title
    })) : /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.img,
      alt: this.props.title
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: calloutGridStyle
    }, this.props.url ? /*#__PURE__*/_react.default.createElement(CalloutHeader, {
      url: this.props.url,
      title: this.props.title
    }) : /*#__PURE__*/_react.default.createElement(CalloutHeader, {
      title: this.props.title
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "callout-body grid12"
    }, this.props.content, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), this.props.url ? /*#__PURE__*/_react.default.createElement("div", {
      className: "centeredbutton"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: calloutTarget,
      rel: "noopener noreferrer"
    }, this.props.title)) : null)));
  }
}

/* ========== CALLOUT HEADER ========== */
exports.Callout = Callout;
_defineProperty(Callout, "propTypes", {
  url: _propTypes.default.string,
  img: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  content: _propTypes.default.string.isRequired,
  direction: _propTypes.default.string,
  columnCount: _propTypes.default.number
});
class CalloutHeader extends _react.Component {
  render() {
    const calloutTarget = this.props.url && this.props.url.substring(0, 4).toLowerCase() === 'http' ? '_blank' : '_self';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "callout-header grid12"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: calloutTarget,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "callout-title"
    }, this.props.title)) : /*#__PURE__*/_react.default.createElement("h2", {
      className: "callout-title"
    }, this.props.title));
  }
}
exports.CalloutHeader = CalloutHeader;
_defineProperty(CalloutHeader, "propTypes", {
  title: _propTypes.default.string.isRequired,
  url: _propTypes.default.string
});
class CalloutRoundSm extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "grid4fix pad"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "grid12 round-img-container"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.img,
      alt: this.props.title
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid12 callout-header"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "callout-title"
    }, this.props.title))));
  }
}
exports.CalloutRoundSm = CalloutRoundSm;
_defineProperty(CalloutRoundSm, "propTypes", {
  url: _propTypes.default.string.isRequired,
  img: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired
});
class CalloutRoundTiny extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: this.props.img ? 'grid' + this.props.gridSize + 'fix round-img-container' : 'grid' + this.props.gridSize + 'fix noMobile'
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.img,
      alt: this.props.alt
    })));
  }
}
exports.CalloutRoundTiny = CalloutRoundTiny;
_defineProperty(CalloutRoundTiny, "defaultProps", {
  gridSize: '2'
});
_defineProperty(CalloutRoundTiny, "propTypes", {
  url: _propTypes.default.string.isRequired,
  img: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  alt: _propTypes.default.string.isRequired,
  gridSize: _propTypes.default.string
});